import styled from 'styled-components'

const Container = styled.div`
    position: fixed;
    top: 10px;
    right: 10px;
    z-index: 999;
    display: {props => props.isShow ? 'block' : 'none'};
`

const Item = styled.div`
    width: 280px;
    background: #FFF;
    border-radius: 10px;
    padding: 8px;
    display: flex;
    margin-bottom: 10px;
    align-items: center;
    transition: all 0.4s ease;
    cursor: pointer;
    box-shadow: rgba(0, 0, 0, 0.4) 0px 1px 8px 1px;
    position: relative;
    &:hover {
        background: #d7d7d7;
    }
`

const Avatar = styled.img`
    width: 40px;
    height: 40px;
    border-radius: 50%;
`

const Content = styled.div`
    font-size: 13px;
    white-space: nowrap;
    text-overflow: ellipsis;
    overflow: hidden;
    width: 240px;
`

const ItemContent = styled.div`
    margin-left: 10px;
`

const Name = styled.div`
    font-size: 14px;
    font-weight: 600;
    white-space: nowrap;
    text-overflow: ellipsis;
    overflow: hidden;
    width: 240px;
`

const CloseAction = styled.div`
    position: absolute;
    right: 10px;
    top: 0px;
    width: 13px;
    height: 13px;
    cursor: pointer;
`

export {
    Container,
    Item,
    Avatar,
    Content,
    ItemContent,
    Name,
    CloseAction
}